import axios from '../Api/api';

export default function level() {
    return new Promise((resolve, reject) => {
        axios.get("home/vipLevel", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
